import { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getCostos,AddCostos,getCostosByName } from "../../actions/costos.jsx";
import { Link } from "react-router-dom";
import style from "../../styles/grid.module.css";
import { FcMultipleSmartphones } from "react-icons/fc";
import edit from "../../images/edit.png";
import { GetCostos } from "../../actions/costo";
import { GetServicios } from "../../actions/servicio";

export default function Costo() {
   const estilo = { fontSize: "200%", transition: "font-size 0.5s" };
   const costos = GetCostos();
   const servicios = GetServicios();
   console.log('servicios: ', servicios,costos);

   return (
      <>
         <div className={style.tableCli}>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Costos</h2>
               </div>
               <div>
                  <Link
                     to={"/formCosto"}
                     className="dLink"
                     title="Alta Costo"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        serv_id: 0,
                        precio: 0,
                        cod_status: 1,
                        servicios: servicios,
                     }}
                  >
                     {" "}
                     <img src={edit} height="30px" alt="" title="Nuevo" />
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
            <div>
               <table className={style.gridTable}>
                  <thead>
                     <tr className={style.trTitle}>
                        <th className={style.title}>ID</th>
                        <th className={style.title}>Descripcion</th>
                        <th className={style.title2}>Precio</th>
                        <th>Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {costos &&
                        costos.map((cost) => {
                           return (
                              <tr key={cost.id}  className={style.trGrid} >
                                 <td className={style.style_td}>{cost.id}</td>
                                 <td className={style.style_td}>
                                    {cost.servicio.descripcion}
                                 </td>
                                 <td className={style.title2}>{cost.precio}</td>
                                 <td>
                                    <Link
                                       to={"/formCosto"}
                                       className="dLink"
                                       state={{
                                          id_primary: cost.id_primary,
                                          id: cost.id,
                                          companyId: cost.companyId,
                                          serv_id: cost.serv_id,
                                          precio: cost.precio,
                                          cod_status: cost.cod_status,
                                          servicios: servicios,
                                       }}
                                    >
                                       <img src={edit} height="30px" alt="" />
                                    </Link>
                                 </td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         </div>
      </>
   );
}
